import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Typography } from "@mui/material";
import AnnouncementForm from "../../../views/Announcements/AnnouncementForm";
import Modal from "../../Modal";
import { hideAnnouncementModal } from "../../../redux/actions/announcementsActions";
import { useTranslation } from "react-i18next";
import { announcementsRoute } from "./Announcements";

const AnnouncementCreateDialog = props => {
  const { t } = useTranslation();
  const gotoManagement = () => {
    props.hideAnnouncementModal();
    props.history.push(announcementsRoute[props.dashboard]);
  };

  return (
    <Modal
      showCloseIcon
      disableEnforceFocus
      dialogTitle={
        <Typography variant="h4" color="textPrimary">
          {t("announcements.announcementCreateDialog.title")}
        </Typography>
      }
      open={props.showModal}
      onClose={props.hideAnnouncementModal}
      dialogContent={
        <AnnouncementForm
          singleDateRow
          onCancel={props.hideAnnouncementModal}
          afterSubmit={gotoManagement}
        />
      }
      fullWidth
      maxWidth="sm"
      scrollable
    />
  );
};

AnnouncementCreateDialog.propTypes = {
  history: PropTypes.any
};

const mapStateToProps = state => ({
  showModal: state.announcementsState.showModal,
  error: state.announcementsState.error
});

export default connect(mapStateToProps, { hideAnnouncementModal })(
  AnnouncementCreateDialog
);
